import get from 'lodash.get';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { deviceTypes, supportConstants, applications } from 'z-js-commons';
import { colors, ErrorFeedbackModal, LoginForm, MultipleChoiceSelectionModal, requestStatuses as ZSupportRequestStatuses } from 'z-react-components';
import NotificationSystem from 'react-notification-system';
import { Tutorial } from 'z-tutorial-applier-js';
import { IdpLogin } from '@zanichelli/idp-login-topbar/dist/react';
import { ZanichelliFooter } from '@zanichelli/zanichelli-footer/dist/react';

//actions
import { idpLogin, login, logout, resumeLogin } from '../actions/auth';
import { clearErrorUserNotification, clearUserNotification } from '../actions/UserNotificationActions';
import { sendSupportRequest, resetSupportRequest } from '../actions/SupportRequestActions';

//constants
import { footerLinks, menuLinks } from '../constants/Links';
import { FUNCTIONARY, STUDENT, TEACHER } from '../constants/UserRoles';
// import * as Widgets from 'constants/Widgets';
import { version } from '../../package.json';

import {
    RECAPTCHA_SITE_KEY,
    WIP_MESSAGE,
    FEATURE_TOGGLE_NEW_PUBLIC_HOME,
    IDP_ENV,
    GOOGLE_LOGIN,
    LRS_USERNAME,
    LRS_PASSWORD,
    XAPI_LRS_ENV,
    CURRENT_ENV
} from '../config';

//components
import asyncComponentLoader from '../components/asyncComponentLoader';
import MenuWrapper from '../components/Page/MenuWrapper';
import { ZButton } from '@zanichelli/albe-web-components/react';

//libs
import * as appPropTypes from '../lib/appPropTypes';
import userHasAccess from '../lib/userHasAccess';
import { stopHeartBeat } from '../lib/heartBeat';

//containers
import Credits from './Credits';
import PrivatePage from '../containers/PrivatePage';
import PublicHome from '../components/PublicHome/index';
import LandingV2 from '../containers/landing-v2';

//tutorial
import getTutorialsInformations from '../lib/tutorial/getTutorialsInformations';
import SupportPopover from 'z-react-components/lib/components/SupportPopover';

const tutorialsInformations = [
    require('../constants/TutorialsInformations/aggiunta-esercizi_contatore').default,
    require('../constants/TutorialsInformations/aggiunta-esercizi_pulsantiera').default,
    require('../constants/TutorialsInformations/archivio_anteprima-esercizio-docente').default,
    require('../constants/TutorialsInformations/archivio_tab-esercizi').default,
    require('../constants/TutorialsInformations/archivio_tab-verifiche').default,
    require('../constants/TutorialsInformations/crea-verifica_anteprima-esercizio-docente').default,
    require('../constants/TutorialsInformations/crea-verifica_anteprima-esercizio-INVALSI').default,
    require('../constants/TutorialsInformations/crea-verifica_anteprima-esercizio-prova-comune').default,
    require('../constants/TutorialsInformations/crea-verifica_anteprima-esercizio-Zanichelli').default,
    require('../constants/TutorialsInformations/crea-verifica_contatore').default,
    require('../constants/TutorialsInformations/crea-verifica_creazione-esercizio').default,
    require('../constants/TutorialsInformations/crea-verifica_risultati-docente').default,
    require('../constants/TutorialsInformations/crea-verifica_risultati-INVALSI').default,
    require('../constants/TutorialsInformations/crea-verifica_risultati-speciali-Zanichelli').default,
    require('../constants/TutorialsInformations/crea-verifica_risultati-Zanichelli').default,
    require('../constants/TutorialsInformations/crea-verifica_tab-INVALSI').default,
    require('../constants/TutorialsInformations/crea-verifica_tab-miei-esercizi').default,
    require('../constants/TutorialsInformations/crea-verifica_tab-speciali-Zanichelli').default,
    require('../constants/TutorialsInformations/crea-verifica_tab-Zanichelli').default,
    require('../constants/TutorialsInformations/creazione-esercizi_pulsantiera-steps').default,
    require('../constants/TutorialsInformations/creazione-esercizi_pulsantiera-salvataggio').default,
    require('../constants/TutorialsInformations/dettaglio-nuova-verifica-docente_pulsantiera').default,
    require('../constants/TutorialsInformations/dettaglio-verifica_pulsantiera').default,
    require('../constants/TutorialsInformations/dettaglio-verifica-docente_aggiungi-esercizio').default,
    require('../constants/TutorialsInformations/dettaglio-verifica-docente-salvata_pulsantiera').default,
    require('../constants/TutorialsInformations/dettaglio-verifica-editoriale-modifica_pulsantiera').default,
    require('../constants/TutorialsInformations/generale_menu').default,
    require('../constants/TutorialsInformations/modifica-esercizi_pulsantiera_zanichelli').default,
    require('../constants/TutorialsInformations/modifica-esercizi_pulsantiera_miei_esercizi').default,
    require('../constants/TutorialsInformations/modifica-esercizi_pulsantiera_archivio').default,
    require('../constants/TutorialsInformations/verifica_risultati-INVALSI').default,
    require('../constants/TutorialsInformations/verifica_risultati-prove-speciali-Zanichelli').default,
    require('../constants/TutorialsInformations/verifica_risultati-Zanichelli').default,
    require('../constants/TutorialsInformations/verifica_tab-INVALSI').default,
    require('../constants/TutorialsInformations/verifica_tab-prove-speciali-Zanichelli').default,
    require('../constants/TutorialsInformations/verifica_tab-Zanichelli').default
];

//async containers
const Cart = asyncComponentLoader(() => import('../containers/Cart'));
const EditorialHomeworkDetail = asyncComponentLoader(() => import('../containers/EditorialHomeworkDetail'));
const Exercise = asyncComponentLoader(() => import('../containers/Exercise'));
const HomeworkDetail = asyncComponentLoader(() => import('../containers/HomeworkDetail'));
const MyLibrary = asyncComponentLoader(() => import('../containers/MyLibrary'));
const Profile = asyncComponentLoader(() => import('../containers/Profile'));
const Search = asyncComponentLoader(() => import('../containers/Search'));
const SearchRelatedExercises = asyncComponentLoader(() => import('../containers/SearchRelatedExercises'));
const ZLibrary = asyncComponentLoader(() => import('../containers/ZLibrary'));

const styles = {
    container: {
        background: colors.white,
        minHeight: '100vh'
    },
    top: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%'
    }
};

const ZButtonDark = styled(ZButton)`
    --color-primary01: var(--gray600);
    --color-hover-primary: var(--gray700);

    :active {
        background-color: var(--gray400);
        border-color: var(--gray400);
        color: var(--color-text-inverse);
        box-shadow: var(--shadow-2);
    }
`;

class PageWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggingOut: false,
            isSupportModalOpen: false,
            showModal: false,
            target: null
        };

        this.handleLogin = this.handleLogin.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleIdpLogin = this.handleIdpLogin.bind(this);
    }

    static propTypes = {
        auth: appPropTypes.auth.isRequired,
        clearErrorUserNotification: PropTypes.func.isRequired,
        clearUserNotification: PropTypes.func.isRequired,
        dispatch: PropTypes.func.isRequired,
        errorUserNotification: PropTypes.object,
        history: PropTypes.object,
        idpLogin: PropTypes.func,
        login: PropTypes.func.isRequired,
        logout: PropTypes.func.isRequired,
        resetSupportRequest: PropTypes.func.isRequired,
        resumeLogin: PropTypes.func.isRequired,
        sendSupportRequest: PropTypes.func.isRequired,
        supportRequest: PropTypes.object.isRequired,
        userNotification: PropTypes.object,
        exercisesInCart: PropTypes.object
    };

    static childContextTypes = {
        device: PropTypes.shape({
            type: PropTypes.string.isRequired,
            innerWidth: PropTypes.number.isRequired,
            innerHeight: PropTypes.number.isRequired
        })
    };

    getChildContext() {
        return {
            device: {
                type: deviceTypes.getDeviceType(window.innerWidth),
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight
            }
        };
    }

    componentWillMount() {
        this.props.resumeLogin();
    }

    componentDidMount() {
        const { clearUserNotification } = this.props;
        if (this.notificationSystem && WIP_MESSAGE) {
            this.notificationSystem.addNotification({
                autoDismiss: 600,
                children: this.customNotificationChildren(WIP_MESSAGE),
                dismissible: true,
                level: 'error',
                position: 'tc'
            });
            clearUserNotification();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { clearUserNotification } = this.props;
        const { userNotification, supportRequest } = nextProps;

        if (userNotification.message) {
            this.notificationSystem.addNotification({
                autoDismiss: 6,
                children: this.notificationChildren(userNotification.message),
                dismissible: true,
                level: userNotification.level || 'success',
                position: 'tc'
            });
            clearUserNotification();
        }

        if (supportRequest && supportRequest.showModal) {
            this.setState({ isSupportModalOpen: supportRequest.showModal });
        }
    }

    customNotificationChildren(message) {
        return (
            <div>
                <h3>{'Avviso'}</h3>
                {message}{' '}
                <a
                    href={CURRENT_ENV ? `https://${CURRENT_ENV}-esercizi.zanichelli.it` : `https://esercizi.zanichelli.it`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="z-link z-link-blue"
                >
                    {'Vai a laZ Esercizi'}
                </a>
            </div>
        );
    }

    /**
     * Translate status from reducer/supportRequest to the corresponding SupportButton status
     * @returns {*}
     */
    getSupportStatus() {
        if (this.props.supportRequest && this.props.supportRequest.sent) {
            if (this.props.supportRequest.error) {
                return ZSupportRequestStatuses.FAILURE;
            } else {
                return ZSupportRequestStatuses.SUCCESS;
            }
        } else {
            // default component status
            return ZSupportRequestStatuses.INITIAL_STATUS;
        }
    }

    handleLogin(credentials) {
        this.props.login(credentials);
    }

    continueHandler() {
        this.setState({ showModal: false });
        this.props.resetSupportRequest();
    }

    handleIdpLogin() {
        this.props.idpLogin();
        this.props.resumeLogin();
    }

    handleLogout() {
        stopHeartBeat();
        this.setState({ isLoggingOut: true });
        window.location = '';
    }

    notificationChildren(message) {
        return (
            <div>
                {/* <Glyphicon glyph="ok"  style={{ paddingRight: 0, fontSize: 35 }} /> */}
                <br />
                {message}
            </div>
        );
    }

    renderErrorMessage() {
        const { clearErrorUserNotification, errorUserNotification } = this.props;
        return (
            <ErrorFeedbackModal message={errorUserNotification.message} onCloseModal={clearErrorUserNotification} showModal={!!errorUserNotification.message} />
        );
    }

    render() {
        const { auth, clearErrorUserNotification, errorUserNotification, logout, history } = this.props;
        const { isSupportModalOpen } = this.state;
        const supportRequest = {
            isKnownUser: auth.isLoggedIn,
            maxFileSize: supportConstants.SUPPORT_REQUEST_MAXSIZE,
            options: supportConstants.SUPPORT_REQUEST_OPTIONS,
            onContinue: () => {
                this.props.resetSupportRequest();
            },
            onClick: e => this.setState({ isSupportModalOpen: true, target: e.target }),
            onHide: () => this.setState({ isSupportModalOpen: false }),
            onSend: supportRequestContent => {
                this.props.sendSupportRequest(auth.isLoggedIn, supportRequestContent);
            },
            siteKey: RECAPTCHA_SITE_KEY,
            showModal: isSupportModalOpen,
            showSupportButton: true,
            status: this.getSupportStatus(),
            userEmail: auth.isLoggedIn && auth.user ? auth.user.loginId : ''
        };

        const userHasAccessCheck = auth.user ? userHasAccess(auth.user, [STUDENT, TEACHER, FUNCTIONARY]) : null;
        const loginId = get(this.props.auth, 'user.loginId');
        const deviceType = deviceTypes.getDeviceType(window.innerWidth);

        const loginErrorMessage = auth && auth.loginError ? auth.loginError.errorMessage : undefined;

        const xapiInfo = {
            environment: XAPI_LRS_ENV,
            platform: applications.CREA_VERIFICHE,
            homepage: CURRENT_ENV ? `https://${CURRENT_ENV}-creaverifiche.zanichelli.it` : `https://creaverifiche.zanichelli.it`,
            lrsCredentials: {
                username: LRS_USERNAME,
                password: LRS_PASSWORD
            }
        };

        return (
            <Tutorial
                tutorialsInformations={getTutorialsInformations(
                    this.props.dispatch,
                    deviceType,
                    tutorialsInformations,
                    get(this.props.auth, 'user.alreadySeenTutorialsIds', []).map(tutorial => tutorial.slice('cv.'.length)),
                    window.location.hash
                )}
            >
                <IdpLogin
                    zainoDigitaleTargetUrl={CURRENT_ENV ? `https://${CURRENT_ENV}-creaverifiche.zanichelli.it` : `https://creaverifiche.zanichelli.it`}
                    xapiInfo={xapiInfo}
                    googleLogin={GOOGLE_LOGIN}
                    showAppSwitcher={true}
                    env={IDP_ENV}
                    key={loginId ? loginId : null}
                    onLoginSuccess={() => {
                        this.handleIdpLogin();
                    }}
                    onLogoutSuccess={() => {
                        this.handleLogout();
                        window.location = '';
                    }}
                    showMyzLink={true}
                />
                {!auth.isLoggedIn && (
                    <LoginForm
                        disabled={auth.isLoggingIn}
                        errorMessage={loginErrorMessage}
                        imageUrl={'./_assets/images/logo.svg'}
                        message={'Crea Verifiche, tante idee per creare la tua verifica in meno tempo.'}
                        onSubmit={this.handleLogin}
                    />
                )}
                <MenuWrapper
                    device={deviceType}
                    footerLinks={footerLinks}
                    logoImgUrl="./_assets/images/logo.svg"
                    logoUrlLink={'/'}
                    menuLinks={menuLinks}
                    show={auth.isLoggedIn && userHasAccessCheck && userHasAccessCheck.hasAccess}
                    supportRequest={supportRequest}
                    version={version}
                />
                <div style={styles.container}>
                    <div style={styles.top}>
                        <NotificationSystem
                            ref={notificationSystem => (this.notificationSystem = notificationSystem)}
                            style={{
                                NotificationItem: {
                                    success: {
                                        backgroundColor: colors.green,
                                        color: colors.white,
                                        fontSize: 16,
                                        fontWeight: 'bold',
                                        borderTop: 'none',
                                        textAlign: 'center'
                                    }
                                },
                                Dismiss: {
                                    success: {
                                        backgroundColor: 'none',
                                        color: colors.white
                                    }
                                }
                            }}
                        />
                        <ErrorFeedbackModal
                            message={errorUserNotification.message}
                            onCloseModal={clearErrorUserNotification}
                            showModal={!!errorUserNotification.message && !auth.heartBeatLogout}
                        />
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <Switch>
                                <PrivatePage auth={auth} authorizedRoles={[TEACHER, FUNCTIONARY]} component={Cart} path="/search/cart" />
                                <PrivatePage auth={auth} authorizedRoles={[TEACHER, FUNCTIONARY]} component={Exercise} path="/search/exercise/:id" />
                                <PrivatePage auth={auth} authorizedRoles={[TEACHER, FUNCTIONARY]} component={Search} path="/search" />
                                <PrivatePage
                                    auth={auth}
                                    authorizedRoles={[TEACHER, FUNCTIONARY]}
                                    component={EditorialHomeworkDetail}
                                    path="/zLibrary/editorialHomeworkDetail/:id"
                                />
                                <PrivatePage
                                    auth={auth}
                                    authorizedRoles={[TEACHER, FUNCTIONARY]}
                                    component={HomeworkDetail}
                                    path="/zLibrary/homeworkDetail/:id"
                                />
                                <PrivatePage auth={auth} authorizedRoles={[TEACHER, FUNCTIONARY]} component={ZLibrary} path="/zLibrary" />
                                <PrivatePage
                                    auth={auth}
                                    authorizedRoles={[TEACHER, FUNCTIONARY]}
                                    component={HomeworkDetail}
                                    path="/myLibrary/homeworkDetail/:id"
                                />
                                <PrivatePage auth={auth} authorizedRoles={[TEACHER, FUNCTIONARY]} component={Exercise} path="/myLibrary/exercise/:id" />
                                <PrivatePage auth={auth} authorizedRoles={[TEACHER, FUNCTIONARY]} component={MyLibrary} path="/myLibrary" />
                                <PrivatePage auth={auth} authorizedRoles={[TEACHER, FUNCTIONARY]} component={Exercise} path="/exercise/:id" />
                                <PrivatePage auth={auth} authorizedRoles={[TEACHER, FUNCTIONARY]} component={Exercise} path="/exercise" />
                                <PrivatePage
                                    auth={auth}
                                    authorizedRoles={[TEACHER, FUNCTIONARY]}
                                    component={SearchRelatedExercises}
                                    path="/searchRelatedExercises"
                                />
                                <PrivatePage auth={auth} authorizedRoles={[STUDENT, TEACHER, FUNCTIONARY]} component={Profile} exact={true} path="/" />
                                <Route component={Credits} path="/credits" />
                                <Route component={FEATURE_TOGGLE_NEW_PUBLIC_HOME === 'enable' ? LandingV2 : PublicHome} />
                            </Switch>
                        </div>
                    </div>
                    {auth.heartBeatLogout ? (
                        <MultipleChoiceSelectionModal
                            choices={[
                                {
                                    content: 'ok',
                                    onSelection: this.handleLogout,
                                    style: {
                                        border: 'none',
                                        textTransform: 'uppercase',
                                        backgroundColor: colors.orange,
                                        color: colors.white
                                    }
                                }
                            ]}
                            content={
                                'Sei stato scollegato perché il tuo account è utilizzato da un’altra postazione o perché sei uscito da myZanichelli. Inserisci di nuovo le tue credenziali per rientrare.'
                            }
                            open={true}
                            showCloseButton={true}
                        />
                    ) : null}
                    <MultipleChoiceSelectionModal
                        choices={[
                            {
                                content: 'Annulla',
                                onSelection: () => this.setState({ isLoggingOut: false }),
                                style: {
                                    border: 'none',
                                    textTransform: 'uppercase',
                                    backgroundColor: colors.grey500,
                                    color: colors.white
                                }
                            },
                            {
                                content: 'Esci',
                                onSelection: () => {
                                    this.setState({ isLoggingOut: false });
                                    logout(loginId);
                                },
                                style: {
                                    border: 'none',
                                    textTransform: 'uppercase',
                                    backgroundColor: colors.orange,
                                    color: colors.white
                                }
                            }
                        ]}
                        onCancel={() => this.setState({ isLoggingOut: false })}
                        content={'È presente una verifica in lavorazione, sei sicuro di voler uscire da Crea Verifiche?'}
                        open={this.state.isLoggingOut && this.state.exercisesInCart && this.state.exercisesInCart.length > 0}
                        showCloseButton={true}
                    />
                </div>
                <SupportPopover
                    target={this.state.target}
                    closePopupFn={() => this.continueHandler()}
                    isKnownUser={supportRequest.isKnownUser}
                    maxFileSize={supportRequest.maxFileSize}
                    options={supportRequest.options}
                    onSend={supportRequestContent => supportRequest.onSend(supportRequestContent)}
                    siteKey={supportRequest.siteKey}
                    status={supportRequest.status}
                    userEmail={supportRequest.userEmail}
                    onContinue={() => supportRequest.onContinue()}
                    onHide={() => supportRequest.onHide()}
                    showModal={supportRequest.showModal}
                />
                <ZanichelliFooter env={IDP_ENV} style={{ lineHeight: 'initial' }}>
                    <div slot="product-version-credits">
                        <span className="footer-app-name body-5-sb">{`Crea Verifiche `}</span>
                        <span className="footer-app-version body-5-sb">{`versione ${version} -  `}</span>
                        <a
                            className="z-link z-link-white"
                            onClick={() => {
                                history.push('/credits');
                            }}
                        >
                            {'Credits'}
                        </a>
                    </div>
                    <div slot="product-button" style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="body-5" style={{ marginRight: '8px' }}>
                            {`Hai bisogno di aiuto?`}
                        </span>
                        <ZButtonDark id="IdZButtonDark" size="small" onClick={e => supportRequest.onClick(e)}>
                            {'SEGNALA UN PROBLEMA'}
                        </ZButtonDark>
                    </div>
                </ZanichelliFooter>
            </Tutorial>
        );
    }
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        errorUserNotification: state.errorUserNotification,
        supportRequest: state.SupportRequestReducer,
        userNotification: state.userNotification,
        exercisesInCart: state.CartReducer.exercisesInCart
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearErrorUserNotification: bindActionCreators(clearErrorUserNotification, dispatch),
        clearUserNotification: bindActionCreators(clearUserNotification, dispatch),
        dispatch: dispatch,
        idpLogin: bindActionCreators(idpLogin, dispatch),
        login: bindActionCreators(login, dispatch),
        logout: bindActionCreators(logout, dispatch),
        resumeLogin: bindActionCreators(resumeLogin, dispatch),
        sendSupportRequest: bindActionCreators(sendSupportRequest, dispatch),
        resetSupportRequest: bindActionCreators(resetSupportRequest, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageWrapper);
